// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".guide[data-v-3803833f]{margin:2.5rem}.guide[data-v-3803833f] {color:#000}.guide[data-v-3803833f]  a{color:#4990e2}.guide[data-v-3803833f]  pre{margin:.5rem 0;padding:.5rem 1rem;border:1px solid #ddd;background-color:#f8f8f8;border-radius:6px}", ""]);
// Exports
module.exports = exports;
